import {
    apiUrl
} from '../../config.json';
import axios from 'axios'

const apiEndPoint = apiUrl + "/dashboard/cards/total"
const token = localStorage.getItem('authToken')
axios.interceptors.request.use(
    config => {
        config.headers.authorization = `Bearer ${token}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
export async function searchDocumentAPI(community, query) {
    let apiToSearch = apiUrl + "/dashboard/search"
    let response = await axios.get(`${apiToSearch}?community=${community}&query=${query}`)
    return await response.data

}
export async function getTotalNumberOfUsers() {
    let response = await axios.get(apiEndPoint + "/users")
    return await response.data
}
export async function getTotalNumberOfFiles() {
    let response = await axios.get(apiEndPoint + "/files")
    return await response.data
}
export async function getTotalNumberOfCollections() {
    let response = await axios.get(apiEndPoint + "/collections")
    return await response.data
}
export async function getTotalNumberOfDepartments() {
    let response = await axios.get(apiEndPoint + "/departments")
    return await response.data
}

export default {
    getTotalNumberOfCollections,
    getTotalNumberOfDepartments,
    getTotalNumberOfFiles,
    getTotalNumberOfUsers,
    searchDocumentAPI
}